/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const UPDATE_MY_PROFILE = gql`
mutation EditMyProfile($bannerImg: String, $bio: String, $image: String, $telephone: String, $givenName: String, $familyName: String) {
    editMyProfile(bannerImg: $bannerImg, bio: $bio, image: $image, telephone: $telephone, givenName: $givenName, familyName: $familyName) {
      email
    }
  }
`;